/* eslint-disable react-hooks/exhaustive-deps */
import {
  Flex,
  Image,
  Link,
  Heading,
  Text,
  Skeleton,
  SkeletonText,
  Icon,
  Button,
} from '@chakra-ui/react'
import {
  WhatsappLogo,
} from '@phosphor-icons/react'

import { useLandingPageProcess } from '../hook/useLandingPageProcess'

import { WhatsAppButton } from '../components/WhatsAppButton'

export function Success() {
  const { landingPageProcess } = useLandingPageProcess()

  if (!landingPageProcess.id) {
    return (
      <>
        <Flex
          w="100%"
          justify="center"
          align="center"
          h={[280, 280, 120]}
          bgColor="#FFF"
        >
          <Flex
            maxW={1200}
            w="100%"
            justify="space-between"
            align="center"
            flexDirection={['column', 'column', 'row']}
            gap="8"
            px="6"
          >
            <Skeleton height="80px" width={200} />

            <Flex gap="4" flexDirection={['column', 'column', 'row']}>
              <Skeleton height="55px" width={200} />

              <Skeleton height="55px" width={200} />
            </Flex>
          </Flex>
        </Flex>

        <Flex flexDirection="column" w="100%" align="center">
          <Skeleton height="400px" width="100%" />

          <Flex
            maxW={1200}
            w="100%"
            justify="space-between"
            flexDirection={['column', 'column', 'row']}
            gap="8"
            p="4"
            my={['8', '12']}
          >
            <Flex
              maxW={550}
              w="100%"
              justify="center"
              flexDirection="column"
              gap="4"
              borderRadius={12}
              p="8"
            >
              <Skeleton height="40px" />
              <SkeletonText
                mt="4"
                noOfLines={8}
                spacing="4"
                skeletonHeight="2"
              />
            </Flex>

            <Flex
              maxW={550}
              w="100%"
              justify="center"
              flexDirection="column"
              gap="4"
              borderRadius={12}
              p="8"
            >
              <Skeleton height="40px" />
              <SkeletonText
                mt="4"
                noOfLines={8}
                spacing="4"
                skeletonHeight="2"
              />
            </Flex>
          </Flex>
        </Flex>
      </>
    )
  }

  return (
    <>
      <Flex
        as="header"
        w="100%"
        justify="center"
        align="center"
        position="fixed"
        zIndex="1000"
        h={[280, 280, 100]}
        bgColor={!landingPageProcess.colorHeader ? '#FFFFFF' : landingPageProcess.colorHeader}
      >
        <Flex
          maxW={1280}
          w="100%"
          justify="space-between"
          align="center"
          flexDirection={['column', 'column', 'row']}
          gap="8"
          px="6"
        >
          <Image
            src={landingPageProcess.urlLogo.split('^')[0]}
            alt="Logo"
            maxW={180}
            w="100%"
          />
        </Flex>
      </Flex>

      <Flex
        as="main"
        flexDirection="column"
        w="100%"
        pt={[280, 280, 100]}
        align="center"
      >
        {landingPageProcess.whatsappNumber && (
          <WhatsAppButton
            href={`http://wa.me/${landingPageProcess.whatsappNumber}/?text=Ola`}
          />
        )}

        <Flex w="100%" justify="center">
          <Image
            src={landingPageProcess.urlBanner.split('^')[0]}
            alt=""
            maxW={1920}
            w="100%"
          />
        </Flex>

        <Flex
          w="100%"
          maxW={1280}
          flexDirection="column"
          align="center"
          gap="8"
          p="4"
          my={['8', '12']}
        >
          <Heading
            as="h2"
            textAlign="center"
            color={landingPageProcess.colorBase}
          >
            {landingPageProcess.titleThanks}
          </Heading>

          <Text
            maxW={900}
            textAlign="center"
            fontSize="lg"
            dangerouslySetInnerHTML={{
              __html: landingPageProcess.descriptionThanks,
            }}
          ></Text>

          {landingPageProcess.whatsappNumber && (
            <>
              <Text
                maxW={900}
                textAlign="center"
                mt="8"
                dangerouslySetInnerHTML={{
                  __html:
                    landingPageProcess.titleThanksWhatsapp === ''
                      ? 'Fale conosco pelo nosso WhastApp!'
                      : landingPageProcess.titleThanksWhatsapp,
                }}
              ></Text>

              <Button
                as={Link}
                href={`http://wa.me/${landingPageProcess.whatsappNumber}/?text=Aguardo o retorno a respeito da minha denuncia.`}
                target="_blank"
                rel="noopener"
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap="2"
                size="lg"
                color="white"
                bg="#34af23"
                border="2px solid transparent"
                _hover={{
                  textDecoration: 'none',
                  borderColor: '#34af23',
                  bg: 'transparent',
                  color: '#34af23',
                }}
              >
                <Icon as={WhatsappLogo} fontSize="30" />
                Clique aqui
              </Button>
            </>
          )}
        </Flex>
      </Flex>
    </>
  )
}
